import { useAppDispatch, useSelector } from "../../../../redux-store";
import { useEffect } from "react";
import { loadDocuments } from "../../../../ducks/data/cargo-documents";
import { selectCargoDocuments } from "../../../../ducks/data/cargo-documents/selectors";
import DocumentsList from "../components/DocumentsList";

type ExistingDocumentsListProps = {
  cargoId: string;
  previewMode: boolean;
  onRemoveItemClick: (id: string) => void;
};

const ExistingCargoDocumentsList = (props: ExistingDocumentsListProps) => {
  const { cargoId, onRemoveItemClick, previewMode } = props;
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(loadDocuments(cargoId));
  }, [dispatch, cargoId]);
  const existingDocuments = useSelector(selectCargoDocuments(cargoId));

  return (
    <>
      {existingDocuments?.length ? (
        <DocumentsList
          previewPosition="left"
          documents={existingDocuments}
          previewMode={previewMode}
          onRemoveItem={onRemoveItemClick}
        />
      ) : null}
    </>
  );
};

export default ExistingCargoDocumentsList;
